import React, { useState } from "react";
// import { createSubjectApi } from "../../../api/school";
import { CategoryCreateCompany, GetJobCategories } from "../../services/auth";
import { toastError, toastSuccess } from "../../config/ToastModal";

function Createcategory({ setModalClose, setCategoryData, handleCloseModal }) {
  const [category, setcategory] = useState("");
  const [images, setImages] = useState({
    localImage: "",
    sendImage: "",
  });

  const { localImage, sendImage } = images;

  const createcategorys = async () => {
    try {
      if (!category || !sendImage) {
        toastError("Please Enter category, image upload...");
      }
      if (category && sendImage) {
        const data = {
          category: category,
          image: sendImage,
        };
        const formDataSend = new FormData();
        for (let a in data) {
          formDataSend.append(`${a}`, data[a]);
        }
        const result = await CategoryCreateCompany(formDataSend);
        if (result) {
          const response = await GetJobCategories();

          if (response) {
            setCategoryData(response?.result);
          }
          setcategory("");
          setModalClose("Close");
          handleCloseModal();
        } else {
          setModalClose("");
        }
      }
    } catch (error) {
    }
  };

  const handleChangeIMage = (e) => {
    const local = e.target.files[0];
    const convertLocalUrl = URL.createObjectURL(local);

    if (local) {
      setImages({
        localImage: convertLocalUrl,
        sendImage: local,
      });
    }
  };

  const imageDelete = () => {
    setImages({
      localImage: "",
      sendImage: "",
    });
  };
  return (
    <div className="p-1">
      <div className="p-1">
        <div>
          <h3></h3>
        </div>

        <div>
          <div className="mt-3 mb-3 col-lg-12">
            <label>
              Category <span className="text-danger">*</span>
            </label>
            <input
              placeholder="Please enter category..."
              onChange={(e) => setcategory(e.target.value)}
              value={category}
              name="category"
              style={{
                border: "1px solid #ececec",
                padding: "10px",
                borderRadius: "10px",
                width: "100%",
              }}
            />
          </div>

          <div className="mt-4" style={{ paddingLeft: "0px" }}>
            <label>
              Image Upload <span className="text-danger">*</span>
            </label>
            <div className="mt-2">
              <input
                type="file"
                accept="image/*"
                id="categoryImage"
                style={{ display: "none" }}
                onChange={handleChangeIMage}
              />
            </div>
            <div style={{ position: "relative" }}>
              <label htmlFor="categoryImage" style={{ cursor: "pointer" }}>
                {localImage ? (
                  <>
                    <img
                      src={localImage}
                      alt="no image"
                      style={{
                        width: "200px",
                        height: "200px",
                        border: "1px solid #e0e4e7",
                        borderRadius: "10px",
                        objectFit: "cover",
                      }}
                    />
                  </>
                ) : (
                  <>
                    <img
                      src={
                        "https://img.freepik.com/free-vector/video-upload-concept-illustration_114360-4702.jpg"
                      }
                      alt="no image"
                      style={{
                        width: "200px",
                        height: "200px",
                        border: "1px solid #e0e4e7",
                        borderRadius: "10px",
                      }}
                    />
                  </>
                )}
              </label>
              {localImage ? (
                <>
                  <div
                    className="d-flex"
                    style={{ display: "flex", gap: "20px", paddingTop: "10px" }}
                  >
                    <div className="cursor">
                      <label
                        style={{
                          cursor: "pointer",
                          color: "blue",
                          fontWeight: "600",
                        }}
                        htmlFor="categoryImage"
                      >
                        {" "}
                        Edit
                      </label>
                    </div>
                    <div className="cursor" style={{ color: "red !important" }}>
                      <label
                        style={{
                          cursor: "pointer",
                          color: "red",
                          fontWeight: "600",
                        }}
                        onClick={imageDelete}
                      >
                        Delete
                      </label>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="mt-4 mb-5">
            <button onClick={createcategorys} className="btn-style-one">
              Create
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Createcategory;
